var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"app",class:{ hide: _vm.hide },attrs:{"id":"app"}},[_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[_c('div',{key:_vm.$root.lang},[(!_vm.$root.lang)?_c('select-language',{on:{"select":_vm.setLanguage}}):_c('div',[_c('TheLayout',{on:{"lang":_vm.setLanguage}})],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }